import axios from 'axios'
import store from '@/store/index'
import { Loading, Message } from 'element-ui'
import router from '@/router'
const instance = axios.create({
  // baseURL: 'http://localhost/api',
  baseURL: '/api',
  timeout: 5000
})
let loading
let loadingCount = 0
function start () {
  loading = Loading.service({
    lock: true,
    text: '加载中',
    background: 'rgba(0,0,0,0.7)'
  })
};
function end () {
  loading.close()
}
function showLoaing () {
  if (loadingCount === 0) {
    start()
  };
  loadingCount++
};

function hideLoading () {
  loadingCount--
  if (loadingCount === 0) {
    end()
  }
}
// let loadingInstance
// 添加请求拦截器
instance.interceptors.request.use(function (config) { // 请求拦截器，分别传入两个回调函数，第一个回调函数是正确发送请求的回调函数，第二个函数是请求发送失败的回调函数(例如请求头不正确)，其中第一个回调函数传入的参数是请求对象
  showLoaing()
  // 只要发请求，就携带token，无论后台是否需要，就是发

  const token = store.getters.token
  if (token) {
    config.headers.authorization = token
    config.headers.platform = 'H5'
  }

  return config
}, function (error) {
  // 对请求错误做些什么
  Message.error('请求发送失败')
  return Promise.reject(error)
})

// 添加响应拦截器
instance.interceptors.response.use(function (response) { // 响应拦截器，也是传入两个回调函数，一个是正确响应的回调函数，一个是响应超时的回调函数
  // 对响应数据做点什么，默认axios会多包装一层
  hideLoading()
  const res = response.data
  if (res.code !== 1) { // 如果响应code不是1，说明正确响应了，但是响应的数据是服务器返回来的错误的数据
    // 抛出一个错误的promise，如果不抛出promise，则await还会往下走，await接到reject型的promise就不往下走了,说明reject中会抛出异常
    Message.error(res.msg)
    if (res.msg.includes('请重新登录') || res.msg.includes('用户未登录')) {
      store.dispatch('user/logout')
      router.push({
        path: '/login',
        query: {
          backUrl: router.currentRoute.fullPath,
          type: 'false'
        }
      }).catch(error => { console.log(error) }) // 会出现重复导肮，所以需要它catch一下，防止出现红屏报错
    }
    console.log('错误消息:' + res.msg)// 非200的响应码，全都是按照错误返回
  }
  res.data = res.data ? res.data : ''// 为了防止空对象访问，导致报错
  return res
}, function (error) {
  // 对响应错误做点什么
  hideLoading()
  Message.error('服务器无响应')
  return Promise.reject(error)
})

export default instance
